<div class="transport-max-header">
    <div>
       {{viewModeText(viewMode)}}
    </div>
</div>

<ng-container *ngIf="transportMaxDetails.controls.length" [formGroup]="transportMaxForm">
    <table formArrayName="transportMaxDetails" class="alternateColor" aria-describedby="">
        <th id="header" style="width : 10%">
                <div class=" form-control m-2 border-0">{{'departmentCapacity.total'| translate}}</div>
                <div class=" form-control p-0 border-0" style="font-size : 0.5rem; background-color: #f5f6f8; height: 2.9rem"></div>
            
                <div class=" form-control m-2 border-0">{{totalCapacity}}</div>
        </th>
        <td *ngFor="let day of transportMaxDetails.controls; let i = index" [formGroupName]="i">
            <tr>
                <div class=" form-control m-2 border-0" style="margin-left: -0.5rem !important">{{getWeekDays(day.value.dayOfWeek)}}</div>
            </tr>
            <tr >
                <div class=" form-control m-2 border-0" style="font-size : 0.7rem; margin-left: -0.5rem !important;">{{day.value.hoursOfOperation === 'Closed' ? ('departmentCapacity.closed'| translate): day.value.hoursOfOperation   }}</div>
            </tr>
            <tr >
                <input [readonly]="day.value.hoursOfOperation === 'Closed'" type="number" min="0" class="form-control m-2" formControlName="slotCapacity" />
            </tr>
        </td>
    </table>
</ng-container>
